// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.focuson-share {
  padding: 1rem 0;
  border-bottom: 1px solid var(--default-border-color);
}
.focuson-card_cover {
  display: block;
  position: relative;
}
.focuson-card_cover-image img {
  display: block;
  width: 100%;
}
.focuson-card_play-button {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(https://assets.adam-webcast.com/assets/icons/play-100.png);
  background-size: 100px;
  z-index: 100;
  background-position: center center;
  background-repeat: no-repeat;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/FocusOn/FocusOn.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,oDAAA;AAAR;AAIQ;EACI,cAAA;EACA,kBAAA;AAFZ;AAIgB;EACI,cAAA;EACA,WAAA;AAFpB;AAMQ;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gFAAA;EACA,sBAAA;EACA,YAAA;EACA,kCAAA;EACA,4BAAA;AAJZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
